import {Component,Inject} from 'ng-metadata/core';

import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {JournalsService} from "../../../journals/journals.service";
import {getVid} from "../../../appConfig/appConfigForward";
import {DatabasesService} from "../../../journals/databases.service";
import {NewspapersService} from '../../../newspapers/newspapers.service';
import {SearchService} from '../../search.service';
import {MediaQueries} from "../../../infra/mediaQueries.service";
import {ChangeLangService} from '../../../infra/lang/changeLang.service';
//your imports go here
const isEqual = require('lodash/isEqual');


@Component({
selector: 'prm-back-to-search-results-button',
templateUrl: 'components/search/fullView/backToSearchResultsButton/back-to-search-results-button.html',
})



export class PrmBackToSearchResultsButton{
    private backToBrowseLabel: string;

    constructor(@Inject('$stateParams')  private $stateParams:ng.ui.IStateParamsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private searchService: SearchService,
                private journalsService: JournalsService,
                private databasesService: DatabasesService,
                private newspapersService : NewspapersService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private changeLangService: ChangeLangService,
                private mediaQueries: MediaQueries) {
        if (this.isBrowseMode){
            this.initBackToBrowseLabel();
        }
    }

    private navigateBackToSearchResults(){
        let params={    vid: this.$stateParams['vid'],
                        query: this.$stateParams['query'],
                        search_scope: this.$stateParams['search_scope'],
                        tab: this.$stateParams['tab'],
                        sortby: this.$stateParams['sortby'],
                        facet: this.$stateParams['facet'],
                        mode: this.$stateParams['mode'],
                        pfilter: this.$stateParams['pfilter'],
                        offset: this.$stateParams['offset'],
                        journals: this.$stateParams['journals'],
                        databases: this.$stateParams['databases'],
                        pcAvailability: this.$stateParams['pcAvailability'],
                        searchInFulltext: this.$stateParams['searchInFulltext'],
                        searchCDI: this.$stateParams['searchCDI'],
                        citationTrailFilterByAvailability: this.$stateParams['citationTrailFilterByAvailability'],
                        lang: this.$translate.use()
                    };
        let state = STATE_NAMES.SEARCH;

        if(this.$stateParams["fromFeaturedResult"]){
            this.resetFeaturedResultsParams(params);
        }

        if(this.journalsService.isJournalSearch()){
            state = STATE_NAMES.JOURNAL_SEARCH;
        }
        if(this.databasesService.isDBSearch()){
            state = STATE_NAMES.DB_SEARCH;
        }
        if(this.newspapersService.isNewspapersSearch()){
            state = STATE_NAMES.NEWSPAPERS;
        }
        console.log ('Back URL from full view: Remove title, decription and schema.org of closed item.');
        this.searchService.removeSEOData();
        
        this.$state.go(state, params, {reload: false});
    }

    private isBackToSearchRequired(){
        if (this.$stateParams['mode'] === 'browse' && this.isFullView && !this.isDeeplinkAfterCallnumberBrowse && !this.isCameFromPerson){
            return false;
        }
        if(this.$stateParams['query'] || this.isBrowseMode || this.isAuthorityMode || this.isCameFromPerson || (this.isPersonMode && this.$state.params['docid'])){
            return true;
        }
        return false;
    }

    public initBackToBrowseLabel(){
        if (this.browseScope){
            let scopeToLabelCode= {
                subject: 'subjects',
                author:'authors',
                title: 'titles',
                series: 'series'
            }
            if(this.$stateParams['browseScope'].includes('callnumber')){
                this.$translate('browse.back.to.callnumbers').then((label)=>{
                    this.backToBrowseLabel= label;
                });
            }
            // This is for Primo VE. There are multiple subject browse options.
            else if(this.$stateParams['browseScope'].includes('subject')){
                this.$translate('browse.back.to.subjects').then((label)=>{
                    this.backToBrowseLabel= label;
                });
            }
            else{
                this.$translate('browse.back.to.' + scopeToLabelCode[this.$stateParams['browseScope']]).then((label)=>{
                    this.backToBrowseLabel= label;
                });
            }
        }      
    }

    get isBrowseMode(){
        return this.$stateParams['mode'] === 'browse' && !this.isPersonMode;
    }

    get isAuthorityMode(){
        return this.$stateParams['mode'] === 'authority' && !this.isPersonMode;
    }

    get browseScope(){
        return this.$stateParams['browseScope'];
    }

    get browseState(){
        return STATE_NAMES.BROWSE_SEARCH;
    }

    get authorityState(){
        return STATE_NAMES.AUTHORITY_SEARCH;
    }

    get backToBrowseParams(){
        return {
            vid: getVid(),
            browseQuery: this.$stateParams['browseQuery'],
            browseScope: this.$stateParams['browseScope'],
            browseFirstTerm: this.$stateParams['browseFirstTerm'],
            innerPnxIndex: this.$stateParams['innerPnxIndex'],
            numOfUsedTerms: this.$stateParams['numOfUsedTerms'],
            fn: this.$stateParams['fn'],
            lang: this.$translate.use()
        }
    }

    get backToAuthorityParams(){
        return {
            vid: getVid(),
            authorityQuery : this.$stateParams['prevAuthQuery'],
            searchField : this.$stateParams['prevAuthField'],
            offset : 0,
            lang: this.$translate.use()
        }
    }
    
    private isRTL () {
        return this.changeLangService.direction === 'rtl';
    }

    get isPersonMode(){
        return this.$state.current.name === 'personEntityPage';
    }

    get isCameFromPerson(){
        return this.$stateParams["prevPersonId"];
    }

    get isFullView(){
        return this.$state.current.name === 'fulldisplay';
    }

    get isDeeplinkAfterCallnumberBrowse(){
        /* fn URL param will appear only for deeplinks that are opened after callnumber searches, where the "back to" button should appear.
        deeplinks that are opened after title/subject/author browse won't have the fn param and the "back to" button should be hidden*/
        return this.$stateParams["fn"];
    }

    public navigateBackForPersonPage(){
        this.isCameFromPerson ? this.navigateBackToPersonPage() : this.navigateBackToFullView();
    }

    private navigateBackToFullView(){
        let params= this.$state.params;
        let state = STATE_NAMES.FULL_DISPLAY;

        if (params.fromFeaturedResult){
            this.resetFeaturedResultsParams(params);
        }

        if (isEqual(params.fromJournalSearch,'true')){
            state = STATE_NAMES.JOURNAL_FULL_DISPLAY;
        }

        this.$state.go(state, params, {reload: false});
    }

    private navigateBackToPersonPage(){
        let params= this.$state.params;
        params.personId=params.prevPersonId;
        params.prevPersonId = undefined;
        params.docid = undefined;
        params.context = undefined;
        params.offset = undefined;
    
        if(params.fromFeaturedResult){
            this.resetFeaturedResultsParams(params);
        }

        this.$state.go(STATE_NAMES.PERSON_ENTITY_PAGE, params, {reload: true});
    }

    private resetFeaturedResultsParams(params){
        params.tab = this.$stateParams['originTab'];
        params.search_scope = this.$stateParams['originScope'];
        params.originTab = undefined;
        params.originTab = undefined;
        params.fromFeaturedResult = undefined;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/backToSearchResultsButton/backToSearchResultsButton.directive.ts